import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

export default class FadeIn extends React.Component {
    render() {
        return (
            <TransitionGroup>
                <CSSTransition
                    appear
                    classNames="content"
                    timeout={{ exit: 0, enter: this.props.timeout }}
                >
                    <div>{this.props.children}</div>
                </CSSTransition>
            </TransitionGroup>
        );
    }
}

FadeIn.defaultProps = {
    timeout: 200,
};

FadeIn.propTypes = {
    timeout: PropTypes.number.isRequired,
};
